import { render, staticRenderFns } from "./ChangeStatusMedicineCabineDialog.vue?vue&type=template&id=1255e8e0&scoped=true&lang=pug&"
import script from "./ChangeStatusMedicineCabineDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeStatusMedicineCabineDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeStatusMedicineCabineDialog.vue?vue&type=style&index=0&id=1255e8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255e8e0",
  null
  
)

export default component.exports